import { addDisplayName, addProps, flowMax } from 'ad-hok'
import cx from 'classnames'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'

import { ReactComponent as AddIcon } from '../assets/add.svg'
import { ReactComponent as BackRodeoIcon } from '../assets/back-rodeo-icon.svg'
import { ReactComponent as BackIcon } from '../assets/back.svg'
import { ReactComponent as BehindTheGateIcon } from '../assets/behind-the-gate-icon.svg'
import { ReactComponent as BrandsIcon } from '../assets/brands.svg'
import { ReactComponent as CameraIcon } from '../assets/camera-icon.svg'
import { ReactComponent as CategoriesIcon } from '../assets/categories.svg'
import { ReactComponent as CheckIcon } from '../assets/check.svg'
import { ReactComponent as ChevronRightIcon } from '../assets/chevron-right-icon.svg'
import { ReactComponent as ClearInputIcon } from '../assets/clear-input-icon.svg'
import { ReactComponent as ClockwiseArrowsIcon } from '../assets/clockwise-arrows.svg'
import { ReactComponent as CloseRodeoIcon } from '../assets/close-rodeo-icon.svg'
import { ReactComponent as CloseIcon } from '../assets/close.svg'
import { ReactComponent as CopyIcon } from '../assets/copy-icon.svg'
import { ReactComponent as CreateManuallyIcon } from '../assets/create-manually-icon.svg'
import { ReactComponent as CreateIcon } from '../assets/create.svg'
import { ReactComponent as CreatorFundIcon } from '../assets/creator-fund-icon.svg'
import { ReactComponent as CreatorsIcon } from '../assets/creators.svg'
import { ReactComponent as DarkCloseIcon } from '../assets/dark-close-icon.svg'
import { ReactComponent as DeleteIcon } from '../assets/delete.svg'
import { ReactComponent as DetectedProducts } from '../assets/detected-products.svg'
import { ReactComponent as EditFlippedIcon } from '../assets/edit-16px-flipped.svg'
import { ReactComponent as EditIcon } from '../assets/edit.svg'
import { ReactComponent as EditsIcon } from '../assets/edits-icon.svg'
import { ReactComponent as HideIcon } from '../assets/hide.svg'
import { ReactComponent as LightBulbIcon } from '../assets/light-bulb-icon.svg'
import { ReactComponent as LinkIcon } from '../assets/link.svg'
import { ReactComponent as LoadingIcon } from '../assets/loading-icon.svg'
import { ReactComponent as LogOutIcon } from '../assets/logout.svg'
import { ReactComponent as MediaIcon } from '../assets/media.svg'
import { ReactComponent as MenuIcon } from '../assets/menu.svg'
import { ReactComponent as MyRodeoIcon } from '../assets/my-rodeo-icon.svg'
import { ReactComponent as EditNewIcon } from '../assets/new-edit.svg'
import { ReactComponent as NextIcon } from '../assets/next.svg'
import { ReactComponent as PasteIcon } from '../assets/paste.svg'
import { ReactComponent as ProductsIcon } from '../assets/products.svg'
import { ReactComponent as ProfileIcon } from '../assets/profile-icon.svg'
import { ReactComponent as QueueIcon } from '../assets/queue.svg'
import { ReactComponent as QueuedProducts } from '../assets/queued-products.svg'
import { ReactComponent as RefreshIcon } from '../assets/refresh.svg'
import { ReactComponent as SearchIcon } from '../assets/search-icon.svg'
import { ReactComponent as SettingsIcon } from '../assets/settings.svg'
import { ReactComponent as ShowIcon } from '../assets/show.svg'
import { ReactComponent as AmazonIcon } from '../assets/social/amazon.svg'
import { ReactComponent as ApplePodcastsIcon } from '../assets/social/apple-podcasts.svg'
import { ReactComponent as EmailIcon } from '../assets/social/email.svg'
import { ReactComponent as EtsyIcon } from '../assets/social/etsy.svg'
import { ReactComponent as FacebookIcon } from '../assets/social/facebook.svg'
import { ReactComponent as GoodreadsIcon } from '../assets/social/goodreads.svg'
import { ReactComponent as InstagramIcon } from '../assets/social/instagram.svg'
import { ReactComponent as PinterestIcon } from '../assets/social/pinterest.svg'
import { ReactComponent as QueuedImages } from '../assets/social/queued-images.svg'
import { ReactComponent as SnapchatIcon } from '../assets/social/snapchat.svg'
import { ReactComponent as SpotifyIcon } from '../assets/social/spotify.svg'
import { ReactComponent as TikTokIcon } from '../assets/social/tiktok.svg'
import { ReactComponent as TwitterIcon } from '../assets/social/twitter.svg'
import { ReactComponent as WebsiteIcon } from '../assets/social/website.svg'
import { ReactComponent as XIcon } from '../assets/social/x.svg'
import { ReactComponent as YoutubeIcon } from '../assets/social/youtube.svg'
import { ReactComponent as UserIcon } from '../assets/user.svg'
import { ReactComponent as ShareIcon } from '../assets/white-share-icon.svg'

export const icons = {
  add: AddIcon,
  back: BackIcon,
  backRodeo: BackRodeoIcon,
  'behind-the-gate': BehindTheGateIcon,
  edits: EditsIcon,
  brands: BrandsIcon,
  camera: CameraIcon,
  categories: CategoriesIcon,
  check: CheckIcon,
  'chevron-right': ChevronRightIcon,
  'clear-input': ClearInputIcon,
  'clockwise-arrows': ClockwiseArrowsIcon,
  close: CloseIcon,
  closeRodeo: CloseRodeoIcon,
  'dark-close': DarkCloseIcon,
  copy: CopyIcon,
  create: CreateIcon,
  'create-manually': CreateManuallyIcon,
  'creator-fund': CreatorFundIcon,
  creators: CreatorsIcon,
  delete: DeleteIcon,
  detectedProducts: DetectedProducts,
  edit: EditIcon,
  editFlipped: EditFlippedIcon,
  'edit-new': EditNewIcon,
  hide: HideIcon,
  loading: LoadingIcon,
  'light-bulb': LightBulbIcon,
  link: LinkIcon,
  logOut: LogOutIcon,
  media: MediaIcon,
  menu: MenuIcon,
  'my-rodeo': MyRodeoIcon,
  next: NextIcon,
  paste: PasteIcon,
  products: ProductsIcon,
  profile: ProfileIcon,
  queue: QueueIcon,
  queuedImages: QueuedImages,
  queuedProducts: QueuedProducts,
  refresh: RefreshIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  show: ShowIcon,
  share: ShareIcon,
  user: UserIcon,
  amazon: AmazonIcon,
  etsy: EtsyIcon,
  goodreads: GoodreadsIcon,
  instagram: InstagramIcon,
  pinterest: PinterestIcon,
  snapchat: SnapchatIcon,
  spotify: SpotifyIcon,
  tikTok: TikTokIcon,
  website: WebsiteIcon,
  x: XIcon,
  youtube: YoutubeIcon,
  twitter: TwitterIcon,
  email: EmailIcon,
  facebook: FacebookIcon,
  applePodcasts: ApplePodcastsIcon,
}

export type IconName = keyof typeof icons

const SOCIAL_ICON_COLOR = 'rgba(144, 115, 79, 0.8)'

const DEFAULT_COLORS: Partial<Record<IconName, string>> = {
  amazon: SOCIAL_ICON_COLOR,
  'chevron-right': 'rgba(255, 255, 255, 0.56)',
  close: 'white',
  'create-manually': '#CBA67A',
  goodreads: SOCIAL_ICON_COLOR,
  etsy: SOCIAL_ICON_COLOR,
  instagram: SOCIAL_ICON_COLOR,
  pinterest: SOCIAL_ICON_COLOR,
  profile: 'rgba(255, 255, 255, 0.56)',
  snapchat: SOCIAL_ICON_COLOR,
  spotify: SOCIAL_ICON_COLOR,
  tikTok: SOCIAL_ICON_COLOR,
  website: SOCIAL_ICON_COLOR,
  youtube: SOCIAL_ICON_COLOR,
  twitter: SOCIAL_ICON_COLOR,
  email: SOCIAL_ICON_COLOR,
  facebook: SOCIAL_ICON_COLOR,
  applePodcasts: SOCIAL_ICON_COLOR,
}

interface StyleProps {
  color?: string
}

const useStyles = createUseStyles({
  icon: {
    color: ({ color }: StyleProps) => color,
  },
  clickable: {
    cursor: 'pointer',
  },
})

interface Props {
  name: IconName
  className?: string
  onClick?: () => void
}

const Icon: FC<Props> = flowMax(
  addDisplayName('Icon'),
  addProps(({ name }) => ({
    Component: icons[name],
    classes: useStyles({ color: DEFAULT_COLORS[name] }),
  })),
  ({ Component, className, onClick, classes }) => (
    <Component
      className={cx(classes.icon, !!onClick && classes.clickable, className)}
      onClick={onClick}
    />
  )
)

export default Icon
